const { isServer } = require('../utils/tracking.util');

/** @type {import('@tidal/tracking').TrackingWindowInterface} */
let gtmWindow;

if (!isServer()) {
    gtmWindow = window;
}

/** @type {import('@tidal/tracking').TidalGoogleTagManager} */
module.exports = (eventData) => {
    if (gtmWindow && gtmWindow.dataLayer) {
        gtmWindow.dataLayer.push(eventData);
    }
};
